export default __webpack_public_path__ + "static/media/christmasLogoMedium.de35822f.svg";